import React from 'react'
//  import './header.css'
import {BsLinkedin} from 'react-icons/bs'
import {FaDribbbleSquare} from 'react-icons/fa'
import {FaGithubSquare} from 'react-icons/fa'

const HeaderScocial = () => {
  return (
    <div className='header__socials'>
      <a href='https://www.linkedin.com/in/sadiq-haruna-13a650241' target='_blank' rel="noreferrer" ><BsLinkedin /></a>
      <a href='https://github.com/Charly070321' target='_blank' rel="noreferrer" ><FaGithubSquare /></a>
      <a href='https://dribbble.com/ReignsB' target='_blank' rel="noreferrer"><FaDribbbleSquare /></a>
    </div>
  )
}

export default HeaderScocial